import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useAlert } from '../components/GlobalAlert';
import config from '../config/config';
import './LoginPage.css';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t } = useLanguage();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (!username || !password) {
      setError(t('fillAllFields'));
      setLoading(false);
      return;
    }
    try {
      const result = await login(username, password);
      if (result.success) {
        showAlert(t('loginSuccess'), 'success');
        setTimeout(() => navigate('/dashboard'), 1200);
      } else {
        setError(result.message || t('loginError'));
      }
    } catch {
      setError(t('connectionError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg-center">
      <form className="auth-form" onSubmit={handleSubmit} autoComplete="on">
        <h1 className="auth-title">Mellow</h1>
        <h2 className="auth-heading">{t('welcomeBack')}</h2>
        <p className="auth-sub">{t('loginSubtitle')}</p>
        {error && <div className="auth-error">{error}</div>}
        <div className="auth-input-group">
          <span className="auth-input-icon">👤</span>
          <input
            type="text"
            placeholder={t('enterUsername')}
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="auth-input"
            autoComplete="username"
            required
          />
        </div>
        <div className="auth-input-group">
          <span className="auth-input-icon">🔒</span>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={t('enterPassword')}
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="auth-input"
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => setShowPassword(v => !v)}
            tabIndex={-1}
            aria-label={showPassword ? t('hide') : t('show')}
          >
            {showPassword ? '🙈' : '👁'}
          </button>
        </div>
        <button className="auth-btn" type="submit" disabled={loading}>
          {loading ? t('loggingIn') : t('login')}
        </button>
        <div className="auth-oauth-group">
          {config.ENABLE_GOOGLE_LOGIN && (
            <button
              type="button"
              className="auth-oauth-btn google"
              onClick={() => window.open(config.GOOGLE_AUTH_URL, '_self')}
            >
              <img src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png" alt="Google" className="auth-oauth-icon" />
              Login with Google
            </button>
          )}
          {config.ENABLE_LINE_LOGIN && (
            <button
              type="button"
              className="auth-oauth-btn line"
              onClick={() => window.open(config.LINE_AUTH_URL, '_self')}
            >
              <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg" alt="LINE" className="auth-oauth-icon" />
              Login with LINE
            </button>
          )}
        </div>
        <div className="auth-bottom-text">
          {t('noAccount')} <Link to="/register" className="auth-link">{t('registerHere')}</Link>
        </div>
      </form>
    </div>
  );
}

export default LoginPage;